module.exports = __webpack_public_path__ + "img/vcsconflicting_93497.d58be9ca.png";